import {
  AdhMuxControlClient,
  withAdhMuxControlClient
} from "./chunk-XZWWVN5W.mjs";
import {
  getWorkspaceControlEndpoint
} from "./chunk-7RNMRPVZ.mjs";

// src/api.ts
function isControlSocketUnavailable(error) {
  const message = error instanceof Error ? error.message : String(error);
  return /ENOENT|ECONNREFUSED|EPIPE|socket/i.test(message);
}
async function requestWorkspaceControl(workspaceName, request) {
  try {
    return await withAdhMuxControlClient(workspaceName, (client) => client.request(request));
  } catch (error) {
    if (isControlSocketUnavailable(error)) return null;
    throw error;
  }
}
async function getWorkspaceState(workspaceName) {
  return requestWorkspaceControl(workspaceName, { type: "workspace_state" });
}
async function getWorkspaceSocketInfo(workspaceName) {
  const endpoint = getWorkspaceControlEndpoint(workspaceName);
  const client = new AdhMuxControlClient(workspaceName);
  try {
    await client.connect();
    return { workspaceName, live: true, endpoint };
  } catch (error) {
    if (isControlSocketUnavailable(error)) {
      return { workspaceName, live: false, endpoint };
    }
    throw error;
  } finally {
    await client.close().catch(() => {
    });
  }
}

export {
  requestWorkspaceControl,
  getWorkspaceState,
  getWorkspaceSocketInfo
};
